import styled from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { mediaQueries } from '@sternum/web/config/mediaQueries';
import { ct } from '@sternum/web/utils/theme';

export const Container = styled.div`
  background: ${ct({ Dark: Colors.BrandBlueTheLightest, Light: Colors.BrandBlueTheLightest })};
  min-height: 100vh;
  overflow: hidden;
`;

export const ContentWrapper = styled.div`
  padding: 20px;
  position: relative;
  z-index: 1;

  @media (${mediaQueries.lg}) {
    margin-top: -80px;
    padding: 40px;
  }

  @media (${mediaQueries.xl}) {
    padding: 40px 70px;
  }

  @media (${mediaQueries.xxl}) {
    padding: 40px 130px;
  }

  @media (min-height: 740px) and ${mediaQueries.lg} {
    position: fixed;
    top: 50%;
    right: 0;
    left: 0;
    transform: translateY(-50%);
    margin-top: 0;
  }
`;

export const ContentInnerWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;

  @media (${mediaQueries.lg}) {
    gap: 20px;
    flex-direction: row;
    align-items: center;
  }

  @media (${mediaQueries['3xl']}) {
    gap: 90px;
    justify-content: center;
  }
`;

export const DescriptionWrapper = styled.div`
  position: relative;
  padding-top: 20px;

  @media (${mediaQueries.lg}) {
    padding-top: 0;
    padding-bottom: 80px;
  }

  @media (${mediaQueries.xl}) {
    padding-bottom: 0;
  }
`;

export const CardWrapper = styled.div`
  @media (${mediaQueries.lg}) {
    width: 470px;
    min-width: 470px;
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 240px;

  @media (${mediaQueries.lg}) {
    min-height: 490px;
  }
`;

export const DecorationImgSmall = styled.img`
  display: none;

  @media (${mediaQueries.lg}) {
    display: block;
    width: 543px;
    height: 344px;
    position: absolute;
    left: -120px;
    top: calc(100% - 60px);
  }

  @media (${mediaQueries.xl}) {
    left: 0;
    top: calc(100% + 40px);
  }

  @media (${mediaQueries['3xl']}) {
    display: none;
  }
`;

export const DecorationImgBigWrapper = styled.div`
  position: relative;
`;

export const DecorationImgBig = styled.img`
  display: none;

  @media (${mediaQueries['3xl']}) {
    display: block;
    width: 543px;
    height: 344px;
    position: absolute;
    left: 0;
    top: -80px;
  }
`;
